import React from "react";
//#region types
import { FileViewerInnerProps, FileViewerImageState } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import NoImage from "images/no_image.png";
import { FileViewerContext } from "./context";
//#endregion

class FileViewerNoPreview extends React.Component<FileViewerInnerProps, FileViewerImageState> {
  static contextType = FileViewerContext;
  context!: React.ContextType<typeof FileViewerContext>;

  mounted: boolean = true;

  constructor(props: FileViewerInnerProps) {
    super(props);

    this.state = {
      currentWidth: 0,
      currentHeight: 0,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.setImageWidthHeight();
  }

  componentDidUpdate(prevProps: FileViewerInnerProps) {
    if (
      prevProps.containerWidth !== this.props.containerWidth ||
      prevProps.containerHeight !== this.props.containerHeight
    ) {
      this.setImageWidthHeight();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  setImageWidthHeight = () => {
    const src = NoImage;

    const { containerWidth: frameWidth, containerHeight: frameHeight } = this.props;
    this.getImageDimensions(src).then((data) => {
      if (!this.mounted) return;
      // A dialog only places and sizes its file preview once the shown file reports its size.
      if (!this.props.fullScreen && this.context?.setUploadedFileDimensions) {
        this.context.setUploadedFileDimensions({ width: data.w, height: data.h });
      }

      let calculatedHeight = frameHeight;
      let calculatedWidth = frameWidth;
      if (frameHeight >= frameWidth) {
        calculatedWidth = frameWidth;
        calculatedHeight = (data.h * frameWidth) / data.w;
      } else if (frameHeight < frameWidth) {
        calculatedWidth = (data.w * frameHeight) / data.h;
        calculatedHeight = frameHeight;
      }

      this.mounted &&
        this.setState({
          currentWidth: calculatedWidth,
          currentHeight: calculatedHeight,
        });
    });
  };

  getImageDimensions = (file: string) => {
    return new Promise<{ w: number; h: number }>(function (resolved, rejected) {
      const i = new Image();
      i.onload = function () {
        resolved({ w: i.width, h: i.height });
      };
      i.src = file;
    });
  };

  render() {
    return !this.props.isLoading && this.state.currentHeight && this.state.currentWidth ? (
      <img src={NoImage} width={this.state.currentWidth} height={this.state.currentHeight} />
    ) : (
      <></>
    );
  }
}

export default FileViewerNoPreview;
